module.exports = __webpack_public_path__ + "dojoToolkit.2VTiBwU7.png";